// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-trends {
    background: #ffffff;
    padding: 20px;
    border-radius: 8px;
    margin-top: 30px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.06);
}

    .top-trends h3 {
        font-size: 20px;
        display: flex;
        align-items: center;
        gap: 8px;
        color: #003366;
        margin-bottom: 5px;
    }

.section-desc {
    font-size: 13px;
    color: #666;
    margin-bottom: 16px;
}

.trend-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}

.trend-card {
    flex: 1 1;
    min-width: 250px;
    background: #f7f9fc;
    padding: 15px;
    border-radius: 6px;
    border: 1px solid #dbe2ea;
}

    .trend-card h4 {
        font-size: 16px;
        color: #1a1a1a;
        margin-bottom: 10px;
    }

    .trend-card ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .trend-card li {
        font-size: 14px;
        margin: 6px 0;
    }

.trend.up {
    color: green;
    font-weight: bold;
}

.trend.down {
    color: red;
    font-weight: bold;
}
.top-trends-section {
    padding: 1.5rem;
    background-color: #f9f9f9;
    border-radius: 10px;
}

.top-trends-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
}

.title {
    font-size: 1.25rem;
    font-weight: bold;
    color: #0f172a;
}

.ai-highlight {
    color: #b91c1c;
}

.trend-filters {
    display: flex;
    gap: 10px;
}

.trend-filter-btn {
    background: #f1f1f1;
    border: none;
    padding: 6px 14px;
    border-radius: 20px;
    cursor: pointer;
    font-weight: 500;
    transition: 0.3s;
    color:#000000;
}

    .trend-filter-btn.active {
        background: #111;
        color: #fff;
    }

.trend-card-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
}

.trend-card {
    flex: 1 1 220px;
    background: #fff;
    border-radius: 8px;
    padding: 1rem;
    box-shadow: 0 1px 3px rgba(0,0,0,0.07);
    border-left: 5px solid #d1d5db;
}

.trend-title {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 400;
    font-size: 1.05rem;
}

.trend-stats {
    margin-top: 0.5rem;
    font-size: 0.95rem;
    display: flex;
    align-items: center;
    gap: 0.4rem;
}

.trend-up {
    color: green;
}

.trend-down {
    color: red;
}

.trend-insight {
    font-size: 0.85rem;
    margin-top: 0.5rem;
    color: #374151;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/TopTrends.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,sCAAsC;AAC1C;;IAEI;QACI,eAAe;QACf,aAAa;QACb,mBAAmB;QACnB,QAAQ;QACR,cAAc;QACd,kBAAkB;IACtB;;AAEJ;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;IAEI;QACI,eAAe;QACf,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,UAAU;QACV,SAAS;IACb;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;AAEJ;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;AACjB;;IAEI;QACI,gBAAgB;QAChB,WAAW;IACf;;AAEJ;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sCAAsC;IACtC,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB","sourcesContent":[".top-trends {\n    background: #ffffff;\n    padding: 20px;\n    border-radius: 8px;\n    margin-top: 30px;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.06);\n}\n\n    .top-trends h3 {\n        font-size: 20px;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        color: #003366;\n        margin-bottom: 5px;\n    }\n\n.section-desc {\n    font-size: 13px;\n    color: #666;\n    margin-bottom: 16px;\n}\n\n.trend-grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n}\n\n.trend-card {\n    flex: 1;\n    min-width: 250px;\n    background: #f7f9fc;\n    padding: 15px;\n    border-radius: 6px;\n    border: 1px solid #dbe2ea;\n}\n\n    .trend-card h4 {\n        font-size: 16px;\n        color: #1a1a1a;\n        margin-bottom: 10px;\n    }\n\n    .trend-card ul {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n    }\n\n    .trend-card li {\n        font-size: 14px;\n        margin: 6px 0;\n    }\n\n.trend.up {\n    color: green;\n    font-weight: bold;\n}\n\n.trend.down {\n    color: red;\n    font-weight: bold;\n}\n.top-trends-section {\n    padding: 1.5rem;\n    background-color: #f9f9f9;\n    border-radius: 10px;\n}\n\n.top-trends-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1rem;\n}\n\n.title {\n    font-size: 1.25rem;\n    font-weight: bold;\n    color: #0f172a;\n}\n\n.ai-highlight {\n    color: #b91c1c;\n}\n\n.trend-filters {\n    display: flex;\n    gap: 10px;\n}\n\n.trend-filter-btn {\n    background: #f1f1f1;\n    border: none;\n    padding: 6px 14px;\n    border-radius: 20px;\n    cursor: pointer;\n    font-weight: 500;\n    transition: 0.3s;\n    color:#000000;\n}\n\n    .trend-filter-btn.active {\n        background: #111;\n        color: #fff;\n    }\n\n.trend-card-grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n}\n\n.trend-card {\n    flex: 1 1 220px;\n    background: #fff;\n    border-radius: 8px;\n    padding: 1rem;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.07);\n    border-left: 5px solid #d1d5db;\n}\n\n.trend-title {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-weight: 400;\n    font-size: 1.05rem;\n}\n\n.trend-stats {\n    margin-top: 0.5rem;\n    font-size: 0.95rem;\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n}\n\n.trend-up {\n    color: green;\n}\n\n.trend-down {\n    color: red;\n}\n\n.trend-insight {\n    font-size: 0.85rem;\n    margin-top: 0.5rem;\n    color: #374151;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
